import Home from "./components/Dashboard/Home";

function App() {
    return <Home />;
}

export default App;
